<div class="integration-wrapper">
	<h5 class="section-title">Identyfikatory zewnętrzne</h5>

	@if (isLoadingIntegration()) {
		<div class="loading-center">
			<mat-spinner diameter="32" />
		</div>
	} @else {
		<form [formGroup]="integrationForm" (ngSubmit)="saveIntegration()">
			<div class="fields-row">
				<mat-form-field appearance="outline">
					<mat-label>Nawigator ID</mat-label>
					<input matInput formControlName="nawigator_id" />
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Numer karty kierowcy</mat-label>
					<input matInput formControlName="driver_card" />
				</mat-form-field>
			</div>
			<button mat-flat-button color="primary" type="submit" [disabled]="isSavingIntegration()">
				@if (isSavingIntegration()) {
					<mat-spinner diameter="18" />
				}
				Zapisz
			</button>
		</form>
	}

	<mat-divider class="section-divider" />
	<div class="section-header">
		<div>
			<h5 class="section-title">Dieta (Enova ID)</h5>
			<p class="section-hint">
				Enova ID zmienia się w czasie — dodaj osobny okres dla każdego ID. Miesiąc rozliczany jest ze wszystkich
				ID, których okres go obejmuje.
			</p>
		</div>
		@if (!showEnovaForm()) {
			<button mat-stroked-button color="primary" (click)="openAddEnovaForm()">
				<i class="fas fa-plus"></i> Dodaj okres
			</button>
		}
	</div>

	@if (showEnovaForm()) {
		<mat-card class="form-card">
			<mat-card-content>
				<form [formGroup]="enovaForm" (ngSubmit)="saveEnova()">
					<div class="form-row">
						<mat-form-field appearance="outline">
							<mat-label>Enova ID</mat-label>
							<input matInput formControlName="enova_id" maxlength="255" />
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>Od</mat-label>
							<input
								matInput
								[matDatepicker]="enovaFromPicker"
								formControlName="date_from"
								placeholder="DD.MM.RRRR"
							/>
							<mat-datepicker-toggle matIconSuffix [for]="enovaFromPicker" />
							<mat-datepicker #enovaFromPicker />
							@if (enovaForm.controls.date_from.hasError('matDatepickerParse')) {
								<mat-error>Nieprawidłowa data</mat-error>
							} @else if (enovaForm.controls.date_from.hasError('required')) {
								<mat-error>Wybierz datę początku</mat-error>
							}
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>Do</mat-label>
							<input
								matInput
								[matDatepicker]="enovaToPicker"
								[min]="enovaForm.controls.date_from.value"
								formControlName="date_to"
								placeholder="DD.MM.RRRR"
							/>
							<mat-datepicker-toggle matIconSuffix [for]="enovaToPicker" />
							<mat-datepicker #enovaToPicker />
							<mat-hint>Puste — bez końca</mat-hint>
							@if (enovaForm.controls.date_to.hasError('matDatepickerParse')) {
								<mat-error>Nieprawidłowa data</mat-error>
							} @else if (enovaForm.controls.date_to.hasError('matDatepickerMin')) {
								<mat-error>Data „do” jest wcześniejsza niż „od”</mat-error>
							}
						</mat-form-field>
						<div class="form-actions">
							<button
								mat-flat-button
								color="primary"
								type="submit"
								[disabled]="isSavingEnova() || enovaForm.invalid"
							>
								@if (isSavingEnova()) {
									<mat-spinner diameter="18" />
								}
								Zapisz
							</button>
							<button mat-stroked-button type="button" (click)="cancelEnovaForm()">Anuluj</button>
						</div>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	}

	@if (isLoadingEnova()) {
		<div class="loading-center">
			<mat-spinner diameter="32" />
		</div>
	} @else if (enovaMappings().length === 0) {
		<p class="empty-text">Brak okresów — kierowca nie ma Enova ID.</p>
	} @else {
		<table mat-table [dataSource]="enovaMappings()" class="mappings-table">
			<ng-container matColumnDef="enova_id">
				<th mat-header-cell *matHeaderCellDef>Enova ID</th>
				<td mat-cell *matCellDef="let m">{{ m.enova_id }}</td>
			</ng-container>
			<ng-container matColumnDef="date_from">
				<th mat-header-cell *matHeaderCellDef>Od</th>
				<td mat-cell *matCellDef="let m">{{ m.date_from }}</td>
			</ng-container>
			<ng-container matColumnDef="date_to">
				<th mat-header-cell *matHeaderCellDef>Do</th>
				<td mat-cell *matCellDef="let m">
					@if (m.date_to) {
						{{ m.date_to }}
					} @else {
						<mat-chip-set>
							<mat-chip color="primary" highlighted>Aktywny</mat-chip>
						</mat-chip-set>
					}
				</td>
			</ng-container>
			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef>Akcje</th>
				<td mat-cell *matCellDef="let m" class="actions-cell">
					<button mat-flat-button color="primary" (click)="openEditEnovaForm(m)" matTooltip="Edytuj">
						<span class="btn-content"><i class="fas fa-edit"></i> Edytuj</span>
					</button>
					<button mat-flat-button color="warn" (click)="deleteEnova(m.id)" matTooltip="Usuń">
						<span class="btn-content"><i class="fas fa-trash"></i> Usuń</span>
					</button>
				</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="enovaColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: enovaColumns"></tr>
		</table>
	}

	<mat-divider class="section-divider" />

	<div class="section-header">
		<h5 class="section-title">Podstawa wynagrodzenia (Gratyfikant)</h5>
		@if (!showForm()) {
			<button mat-stroked-button color="primary" (click)="openAddForm()">
				<i class="fas fa-plus"></i> Dodaj
			</button>
		}
	</div>

	@if (showForm()) {
		<mat-card class="form-card">
			<mat-card-content>
				<form [formGroup]="gratyfikantForm" (ngSubmit)="saveGratyfikant()">
					<div class="form-row">
						<mat-form-field appearance="outline" class="field-wide">
							<mat-label>Organizacja</mat-label>
							<mat-select formControlName="organization_id">
								@for (org of organizations(); track org.id) {
									<mat-option [value]="org.id"
										>#{{ org.id }} · {{ org.shortName }} – {{ org.name }}</mat-option
									>
								}
							</mat-select>
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>ID Gratyfikant</mat-label>
							<input matInput formControlName="gratyfikant_id" />
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>Od</mat-label>
							<input matInput type="date" formControlName="date_from" />
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>Do</mat-label>
							<input matInput type="date" formControlName="date_to" />
						</mat-form-field>
						<div class="form-actions">
							<button
								mat-flat-button
								color="primary"
								type="submit"
								[disabled]="isSavingGratyfikant() || gratyfikantForm.invalid"
							>
								@if (isSavingGratyfikant()) {
									<mat-spinner diameter="18" />
								}
								Zapisz
							</button>
							<button mat-stroked-button type="button" (click)="cancelForm()">Anuluj</button>
						</div>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	}

	@if (isLoadingGratyfikant()) {
		<div class="loading-center">
			<mat-spinner diameter="32" />
		</div>
	} @else if (mappingRows().length === 0) {
		<p class="empty-text">Brak wpisów</p>
	} @else {
		<table mat-table [dataSource]="mappingRows()" class="mappings-table">
			<ng-container matColumnDef="organization">
				<th mat-header-cell *matHeaderCellDef>Organizacja</th>
				<td mat-cell *matCellDef="let m">{{ m.organizationLabel }}</td>
			</ng-container>
			<ng-container matColumnDef="gratyfikant_id">
				<th mat-header-cell *matHeaderCellDef>ID Gratyfikant</th>
				<td mat-cell *matCellDef="let m">{{ m.gratyfikant_id }}</td>
			</ng-container>
			<ng-container matColumnDef="date_from">
				<th mat-header-cell *matHeaderCellDef>Od</th>
				<td mat-cell *matCellDef="let m">{{ m.date_from }}</td>
			</ng-container>
			<ng-container matColumnDef="date_to">
				<th mat-header-cell *matHeaderCellDef>Do</th>
				<td mat-cell *matCellDef="let m">
					@if (m.date_to) {
						{{ m.date_to }}
					} @else {
						<mat-chip-set>
							<mat-chip color="primary" highlighted>Aktywny</mat-chip>
						</mat-chip-set>
					}
				</td>
			</ng-container>
			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef>Akcje</th>
				<td mat-cell *matCellDef="let m" class="actions-cell">
					<button mat-flat-button color="primary" (click)="openEditForm(m)" matTooltip="Edytuj">
						<span class="btn-content"><i class="fas fa-edit"></i> Edytuj</span>
					</button>
					<button mat-flat-button color="warn" (click)="deleteGratyfikant(m.id)" matTooltip="Usuń">
						<span class="btn-content"><i class="fas fa-trash"></i> Usuń</span>
					</button>
				</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
		</table>
	}
</div>
